
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/creators",
      function () {
        return require("private-next-pages/creators/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/creators"])
      });
    }
  